import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import Dropdown from '../../../components/v2/Dropdown'
import GenderCard from '../../../components/v2/GenderCard'
import Input from '../../../components/v2/Input'
import MovingPrice from '../../../components/v2/MovingPrice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WarningMessage from '../../../components/v2/WarningMessage'
import AddButton from '../../../components/v2/buttons/AddButton'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { ForMePersonalInfo, GroupedTravelAttachedAddon, NewTravelAttachedAddon } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { TravelAbroadState, setTravelers } from '../../../store/travelAbroadSlice'
import { Helmet } from 'react-helmet-async'
//
//
const AbroadForOther = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const [openAccordion, setOpenAccordion] = useState<number | null>(0)
  //
  const { lang, isProduction } = useAppSelector((root: { app: AppState }) => root.app)
  //
  //
  const travelerRef = useRef<HTMLDivElement | null>(null)
  //
  const travelerFunRef = (index: number) => {
    // @ts-ignore
    travelerRef?.[index]?.current?.scrollIntoView({ behavior: 'smooth' })
  }
  //
  //
  const _toggleAccordion = (index: number) => {
    if (openAccordion === index) {
      setOpenAccordion(null) // Close the currently open accordion
    } else {
      setOpenAccordion(index) // Open the clicked accordion
    }
  }
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  //
  const { screenHeader, filter, checkout } = useAppSelector(
    (data: { travelAbroad: TravelAbroadState }) => data.travelAbroad,
  )
  //
  //
  const [hideFileds, setHideFileds] = useState<boolean>(false)
  //
  //
  type PersonalInfos = {
    UserPersonalInfos: Partial<ForMePersonalInfo>[]
  }
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  // georgian letter regex
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  const letterNumberRegex = /^[a-zA-Z0-9]*$/
  //
  // Sgs request
  const [sgsRequest, { data: sgsResult, isLoading: isSgsResultLoading }] = api.useSgsRequestMutation()
  //
  //
  // #############################################################
  //
  //
  const [travelersCountState] = useState<number | undefined>(filter.travelersDate?.length)
  //
  //
  // travelers array
  const [travelersInfo, setTravelersInfo] = useState<Partial<ForMePersonalInfo>[]>(
    checkout.travelers
      ? checkout.travelers
      : [
          {
            cityzenship: 'GE',
            passportNumber: '',
            idNumber: '',
            email: '',
            dateOfbirth: null,
            gender: '',
            sgsVerification: false,
            sgsVerificationSended: false,
            translations: {
              ge: {
                firstName: '',
                lastName: '',
              },
              en: {
                firstName: '',
                lastName: '',
              },
            },
          },
        ],
  )
  //
  //
  //
  // add traveler
  const handleAddTraveler = () => {
    append({
      cityzenship: 'GE',
      passportNumber: '',
      idNumber: '',
      email: '',
      dateOfbirth: null,
      gender: '',
      sgsVerification: false,
      sgsVerificationSended: false,
      translations: {
        ge: {
          firstName: '',
          lastName: '',
        },
        en: {
          firstName: '',
          lastName: '',
        },
      },
    })
  }
  //
  //
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm<PersonalInfos>({ defaultValues: { UserPersonalInfos: travelersInfo }, mode: 'all' })

  const { append, remove } = useFieldArray({
    control: control,
    name: 'UserPersonalInfos',
    rules: {
      required: { value: true, message: 'Add At least one field' },
    },
  })
  //
  //
  //
  const NextStep = () => {
    return [navigate('/abroad-insurer'), dispatch(setTravelers(travelersInfo))]
  }
  //
  //
  //
  //
  const onSubmit = (userPersonalInfos: PersonalInfos, event: any) => {
    event.preventDefault()
    setTravelersInfo(userPersonalInfos.UserPersonalInfos)
    NextStep()
  }
  //
  // set travelers in current page state
  const data = watch('UserPersonalInfos')
  //
  useEffect(() => {
    setTravelersInfo(data)
  }, [data])
  //
  //
  //
  //
  // add traveler cityzenship
  const handleTravelerCityzenship = (fieldName: string, value: any, index: any) => {
    setValue(`UserPersonalInfos.${index}.cityzenship`, value)
  }
  //
  //
  const userPersonalNumbers = travelersInfo?.map((x) => x?.idNumber)
  //
  const userPassportNumbers = travelersInfo?.map((x) => x?.passportNumber)
  //
  //
  // find duplicate info & personal number & pasport number
  const hasDuplicates = (arr: string[]) => {
    let set = new Set()
    for (let item of arr) {
      if (set.has(item) && item.trim().length >= 2) {
        return true
      } else {
        set.add(item)
      }
    }
    return false
  }
  //
  //
  // #############################################################
  //
  //
  // #########################################################
  //
  const travelersAgeFromRedux = filter.travelersDate?.map((x, i) => `${x.date}-${i}`)
  //
  const incomeDateCounts = {}
  travelersAgeFromRedux?.forEach(function (x) {
    // @ts-ignore
    incomeDateCounts[x] = (incomeDateCounts[x] || 0) + 1
  })
  //
  //
  const travelersDateFromCurrentPage = travelersInfo?.map((x) => x.dateOfbirth)
  //
  const currentDateCounts = {}
  travelersDateFromCurrentPage?.forEach(function (x) {
    // @ts-ignore
    currentDateCounts[x] = (currentDateCounts[x] || 0) + 1
  })
  //
  //
  // check user dates
  const isDeepEqual = (object1: any, object2: any) => {
    const objKeys1 = Object.keys(object1)
    const objKeys2 = Object.keys(object2)

    if (objKeys1.length !== objKeys2.length) return false

    for (var key of objKeys1) {
      const value1 = object1[key]
      const value2 = object2[key]

      const isObjects = isObject(value1) && isObject(value2)

      if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
        return false
      }
    }
    return true
  }

  const isObject = (object: any) => {
    return object != null && typeof object === 'object'
  }
  //
  //
  //
  // dates equal variable
  const isTravelersDateEqual: boolean = isDeepEqual(incomeDateCounts, currentDateCounts)
  //
  //
  //
  //
  //####################################################
  // add uset at addon
  const addUserAtAddon = (index: number, addon: NewTravelAttachedAddon) => {
    const list = [...travelersInfo]
    const existingUserAddons = list[index].addons || []
    list[index]['addons'] = [...existingUserAddons, addon]
    //
    setTravelersInfo(list)
  }
  //
  // remove user at addon
  const removeUserAtAddon = (index: number, addon: NewTravelAttachedAddon) => {
    const list = [...travelersInfo]
    const existingUserAddons = list[index].addons || []
    list[index].addons = existingUserAddons.filter((x) => x.addonId !== addon.addonId)
    setTravelersInfo(list)
  }

  //
  //
  // add group addon
  const addGroupUserAtAddon = (index: number, addon: GroupedTravelAttachedAddon) => {
    const list = [...travelersInfo]
    const existingUserAddons = list[index].groupedAddonInfos || []
    list[index]['groupedAddonInfos'] = [...existingUserAddons, addon]
    //
    setTravelersInfo(list)
  }
  //
  // remove user group  addon
  const removeUserGroupAtAddon = (index: number, addon: GroupedTravelAttachedAddon) => {
    const list = [...travelersInfo]
    const existingUserAddons = list[index].groupedAddonInfos || []
    list[index].groupedAddonInfos = existingUserAddons.filter((x) => x.id !== addon.id)
    setTravelersInfo(list)
  }

  //####################################################
  //
  //
  // ############### at addons
  const calculateAtAddonCounts = (travelers: Partial<ForMePersonalInfo>[]) => {
    const atAddonCounts = {}
    //
    if (travelers) {
      //
      travelersInfo.forEach((traveler) => {
        traveler?.addons?.forEach((addon) => {
          const addonId = addon.addonId
          // @ts-ignore
          if (atAddonCounts[addonId]) {
            // @ts-ignore
            atAddonCounts[addonId]++
          } else {
            // @ts-ignore
            atAddonCounts[addonId] = 1
          }
        })
      })
      //
      return atAddonCounts
    }
  }
  //
  const atAddonCounts = calculateAtAddonCounts(travelersInfo)
  // ############### at addons
  //
  //
  //
  //
  // ############### group at addons
  const calculateGroupAtAddonCounts = (travelers: Partial<ForMePersonalInfo>[]) => {
    const groupAtAddonCounts = {}
    //
    if (travelers) {
      //
      travelersInfo.forEach((traveler) => {
        traveler?.groupedAddonInfos?.forEach((addon) => {
          const addonId = addon.id
          // @ts-ignore
          if (groupAtAddonCounts[addonId]) {
            // @ts-ignore
            groupAtAddonCounts[addonId]++
          } else {
            // @ts-ignore
            groupAtAddonCounts[addonId] = 1
          }
        })
      })
      //
      return groupAtAddonCounts
    }
  }
  //
  const groupAtAddonCounts = calculateGroupAtAddonCounts(travelersInfo)
  // ############### group at addons
  //
  const gendersIsValid = travelersInfo
    ?.map((x) => (x.gender !== undefined && x?.gender?.length <= 1 ? false : true))
    ?.every((value) => value)
  //
  //
  // ######################################## BEGIN S G S
  //
  //
  const convertDateFormat = (inputDate?: string) => {
    if (inputDate !== undefined) {
      const parts = inputDate.split(' / ')
      if (parts.length === 3) {
        const day = parts[0]
        const month = parts[1]
        const year = parts[2].split('-')[0] // Extract the year part before the hyphen
        const formattedDate = `${year}-${month}-${day}`
        return formattedDate
      } else {
        return 'Invalid date format'
      }
    }
    return 'Invalid input'
  }
  //
  //
  // send sgs request by birthday and personal number
  const sendSgsRequest = async (birthday: string, personalNumber: string, index: number) => {
    //
    if (birthday && personalNumber) {
      try {
        //
        await sgsRequest({ birthday, personalNumber }).unwrap()
        //
        travelerFunRef(index)
        //
      } catch (error: any) {
        //
        setHideFileds(false)
        //
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
        }
      }
    }
    //
  }
  //
  //
  //
  // check user end send sgs request & set traveler sgs request is sended or not
  useEffect(() => {
    //
    if (travelersInfo && travelersInfo.length >= 1 && isProduction) {
      //
      travelersInfo.map((traveler, index) => {
        if (
          traveler.sgsVerificationSended === false &&
          traveler.sgsVerification === false &&
          traveler.dateOfbirth &&
          traveler.cityzenship &&
          traveler.cityzenship === 'GE' &&
          traveler.idNumber &&
          traveler.idNumber.length === 11
        ) {
          //
          // format traveler custom date to normal date
          const travelerDate = convertDateFormat(traveler.dateOfbirth as unknown as string)
          //
          // set traveler sgs request is sended
          setValue(`UserPersonalInfos.${index}.sgsVerificationSended`, true)
          //
          // send request in sgs service
          sendSgsRequest(travelerDate, traveler.idNumber, index)
          //
          // hide fields
          setHideFileds(true)
          //
          //
          return null
          //
        } else {
          return null
        }
      })
      //
    }
    //
    return () => {}
  })
  //
  //
  //
  // lock sgs response and is return traveler info, update current traveler info or return current treveler prev info
  const setResponsedTravelerInfo = useCallback(async () => {
    //
    const updatedTraveler = data?.find((x) => x?.idNumber === sgsResult?.personalNumber)
    //
    //
    if (
      isProduction &&
      sgsResult &&
      sgsResult.sgsStatusText &&
      sgsResult.sgsStatusText.toLowerCase() === 'ok' &&
      data &&
      (updatedTraveler ? true : false) &&
      updatedTraveler?.sgsVerification === false &&
      updatedTraveler?.sgsVerificationSended === true
    ) {
      //
      const updatetTraveler: Partial<ForMePersonalInfo>[] = data?.map((traveler) => {
        //
        if (traveler.idNumber === sgsResult.personalNumber) {
          return {
            ...traveler,
            gender: sgsResult.gender,
            sgsVerification: true,
            sgsVerificationSended: true,
            translations: {
              ge: {
                firstName: sgsResult.translations?.ge?.firstName,
                lastName: sgsResult.translations?.ge?.lastName,
              },
              en: {
                firstName: sgsResult.translations?.en?.firstName,
                lastName: sgsResult.translations?.en?.lastName,
              },
            },
          }
          //
        } else {
          //
          return traveler
          //
        }
      })
      //
      // setTravelersInfo(updatetTraveler)
      setValue(`UserPersonalInfos`, updatetTraveler)
      //
      // show fields
      setHideFileds(false)
      //
      //
    } else {
      // show fields
      setHideFileds(false)
    }
    //
  }, [isProduction, data, sgsResult, setValue])
  //
  //
  useEffect(() => {
    setResponsedTravelerInfo()
    //
    return () => {}
  }, [setResponsedTravelerInfo])
  //
  //
  // ######################################## BEGIN S G S
  //
  //
  //
  const handleKeyDown = (event: any) => {
    if (event?.key === 'Enter') {
      event.preventDefault()
    }
  }
  //
  //#################### NEXT STEP VALIDATIONS
  //
  const idNumbersIsValid = travelersInfo.filter((x) => x.idNumber).length === filter.travelersDate?.length
  //
  const cityzenshipsIsValid = travelersInfo.filter((x) => x.cityzenship).length === filter.travelersDate?.length
  //
  const passportsIsValid = travelersInfo.filter((x) => x.passportNumber).length === filter.travelersDate?.length
  //
  //#################### NEXT STEP VALIDATIONS
  //
  // get standart addons selected count by id
  function calculateStandartAddonCounts(travelers: Partial<ForMePersonalInfo>[]) {
    const addonCounts = {}

    travelers.forEach((traveler) => {
      const addons = traveler.addons
      if (addons && Array.isArray(addons)) {
        addons.forEach((addon) => {
          const { addonId } = addon
          // @ts-ignore
          if (addonCounts[addonId]) {
            // @ts-ignore
            addonCounts[addonId]++
          } else {
            // @ts-ignore
            addonCounts[addonId] = 1
          }
        })
      }
    })

    const addonsWithCount = Object.keys(addonCounts).map((addonId) => ({
      addonId: parseInt(addonId),
      // @ts-ignore
      count: addonCounts[addonId],
    }))

    return addonsWithCount
  }
  //
  // get grouped addons selected count by id
  function calculateGroupedAddonCounts(travelers: Partial<ForMePersonalInfo>[]) {
    const addonCounts = {}

    travelers.forEach((traveler) => {
      const addons = traveler.groupedAddonInfos
      if (addons && Array.isArray(addons)) {
        addons.forEach((addon) => {
          const { id } = addon
          // @ts-ignore
          if (addonCounts[id]) {
            // @ts-ignore
            addonCounts[id]++
          } else {
            // @ts-ignore
            addonCounts[id] = 1
          }
        })
      }
    })

    const addonsWithCount = Object.keys(addonCounts).map((addonId) => ({
      addonId: parseInt(addonId),
      // @ts-ignore
      count: addonCounts[addonId],
    }))

    return addonsWithCount
  }
  //
  const standartAddonSelectedCountByid = calculateStandartAddonCounts(travelersInfo)
  const groupedAddonSelectedCountByid = calculateGroupedAddonCounts(travelersInfo)
  //
  const standartAddonTotalCount =
    standartAddonSelectedCountByid?.reduce((total, traveler) => total + traveler.count, 0) || 0
  const groupedAddonTotalCount =
    groupedAddonSelectedCountByid?.reduce((total, traveler) => total + traveler.count, 0) || 0
  //
  const standartAddonFromFilter = filter.attachedAddons?.reduce((prev, next) => prev + next.count, 0) || 0
  const groupedAddonFromFilter = filter.groupedAttachedAddons?.reduce((prev, next) => prev + next.count, 0) || 0
  //
  const totalUsedAddonCount = standartAddonTotalCount + groupedAddonTotalCount
  const totalFilterAddonCount = standartAddonFromFilter + groupedAddonFromFilter
  //
  const notUsedAddonCount = totalFilterAddonCount - totalUsedAddonCount
  //
  const allAddonIsSelected = totalFilterAddonCount === totalUsedAddonCount ? true : false
  //
  const MainLoading = isCountriesLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('travelerInformation')}</title>
        <meta name="description" content={`${t('travelerInformation')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {isSgsResultLoading ? <Loader text={t('dataProcessing')} /> : null}

      <form onSubmit={(event) => event.preventDefault()}>
        <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

        {hideFileds ? null : (
          <Content>
            <Title text={t('travelerInformation')} />

            <AbroadProgressBar stepName={`${t('travelers')}`} />

            <MovingPrice price={filter.offerTotalPrice} />

            {travelersInfo?.map((item, index) => {
              //
              //
              return (
                <WhiteBox key={index} ref={travelerRef}>
                  <BlockHead>
                    <CloseButton onClick={() => _toggleAccordion(index)}>
                      <RightArrow
                        style={{
                          transform: openAccordion === index ? `rotate(0deg)` : `rotate(-180deg)`,
                        }}
                      />
                    </CloseButton>

                    <BoxTitle onClick={() => _toggleAccordion(index)}>
                      {t('traveller')} {index + 1}
                    </BoxTitle>

                    <RemoveBtn
                      style={{
                        pointerEvents: index === 0 ? 'none' : 'unset',
                        userSelect: index === 0 ? 'none' : 'unset',
                        opacity: index === 0 ? '0' : 'unset',
                      }}
                      type="button"
                      onClick={() => remove(index)}
                    >
                      <CloseIcon />
                    </RemoveBtn>
                  </BlockHead>

                  {openAccordion === index ? (
                    <Inputs>
                      {countries && (
                        <Dropdown
                          title={`${t('cityzenship')}`}
                          isSearchable={true}
                          value={item.cityzenship || ''}
                          options={[
                            ...countries.map((c) => ({
                              value: c.isoCode,
                              label: c.translations?.[lang]?.name,
                            })),
                          ]}
                          onChange={(event) => handleTravelerCityzenship('cityzenship', event.value, index)}
                        />
                      )}

                      <Input
                        id={`id-number-${index}`}
                        label={t('personalNumber')}
                        type="text"
                        placeholder=""
                        value={item.idNumber}
                        name={`UserPersonalInfos.${index}.idNumber`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.idNumber}
                        errorText={errors.UserPersonalInfos?.[index]?.idNumber?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.idNumber`, {
                          required: { value: true, message: `${t('required')}` },
                          minLength: item.cityzenship === 'GE' ? { value: 11, message: `${t('required')}` } : undefined,
                          maxLength:
                            item.cityzenship === 'GE'
                              ? { value: 11, message: `${t('personalNumberValidation')}` }
                              : undefined,
                          pattern: {
                            value: item.cityzenship === 'GE' ? /^[0-9]+$/ : letterNumberRegex,
                            message:
                              item.cityzenship === 'GE' ? `${t('numberValidation')}` : `${t('letterNumberValidation')}`,
                          },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      {hasDuplicates(userPersonalNumbers as string[]) && ( // probable error
                        <WarningMessage variant="gray" text={t('duplicatePersonalNumber')} />
                      )}

                      {filter && filter.travelersDate && (
                        <Dropdown
                          title={`${t('dateOfBirth')}`}
                          isSearchable={false}
                          value={watch(`UserPersonalInfos.${index}.dateOfbirth`) || ''}
                          options={[
                            ...filter?.travelersDate?.map((t, i) => ({
                              value: `${t.date}-${i}`,
                              label: t.date,
                            })),
                          ]}
                          onChange={(event) => setValue(`UserPersonalInfos.${index}.dateOfbirth`, event.value)}
                        />
                      )}

                      <Input
                        id={`passport-number-${index}`}
                        label={t('passportNumber')}
                        type="text"
                        placeholder=""
                        value={item.passportNumber}
                        name={`UserPersonalInfos.${index}.passportNumber`}
                        width={'fullWidth'}
                        error={
                          !!errors.UserPersonalInfos?.[index]?.passportNumber ||
                          (item.sgsVerificationSended && item.sgsVerification && item.passportNumber === '')
                            ? true
                            : false
                        }
                        errorText={errors.UserPersonalInfos?.[index]?.passportNumber?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.passportNumber`, {
                          required: { value: true, message: `${t('required')}` },
                          maxLength: { value: 9, message: `${t('passportNumberValidation')}` },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      {hasDuplicates(userPassportNumbers as string[]) && ( // probable error
                        <WarningMessage variant="gray" text={t('duplicatePassportNumber')} />
                      )}

                      {item.cityzenship === 'GE' && (
                        <Input
                          id={`name-georgian-${index}`}
                          label={t('nameInGeorgia')}
                          type="text"
                          placeholder=""
                          value={item.translations?.ge?.firstName}
                          name={`UserPersonalInfos.${index}.translations.ge.firstName`}
                          width={'fullWidth'}
                          error={!!errors.UserPersonalInfos?.[index]?.translations?.ge?.firstName}
                          errorText={errors.UserPersonalInfos?.[index]?.translations?.ge?.firstName?.message}
                          formRegistration={register(`UserPersonalInfos.${index}.translations.ge.firstName`, {
                            required: { value: item.cityzenship === 'GE', message: `${t('required')}` },
                            pattern: {
                              value: georgianLetterRegex,
                              message: `${t('enterGeorgianLetterAndRemoveSpaceValidation')}`,
                            },
                            minLength: { value: 2, message: `${t('minNameLetterLenght')}` },
                          })}
                          onKeyPress={handleKeyDown}
                        />
                      )}

                      {item.cityzenship === 'GE' && (
                        <Input
                          id={`surname-georgian-${index}`}
                          label={t('surnameInGeorgia')}
                          type="text"
                          placeholder=""
                          value={item.translations?.ge?.lastName}
                          name={`UserPersonalInfos.${index}.translations.ge.lastName`}
                          width={'fullWidth'}
                          error={!!errors.UserPersonalInfos?.[index]?.translations?.ge?.lastName}
                          errorText={errors.UserPersonalInfos?.[index]?.translations?.ge?.lastName?.message}
                          formRegistration={register(`UserPersonalInfos.${index}.translations.ge.lastName`, {
                            required: { value: item.cityzenship === 'GE', message: `${t('required')}` },
                            pattern: {
                              value: georgianLetterRegex,
                              message: `${t('enterGeorgianLetterAndRemoveSpaceValidation')}`,
                            },
                            minLength: { value: 2, message: `${t('minSurnameLetterLenght')}` },
                          })}
                          onKeyPress={handleKeyDown}
                        />
                      )}

                      <Input
                        id={`name-english${index}`}
                        label={t('nameInEnglish')}
                        type="text"
                        placeholder=""
                        value={item.translations?.en?.firstName}
                        name={`UserPersonalInfos.${index}.translations.en.firstName`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.translations?.en?.firstName}
                        errorText={errors.UserPersonalInfos?.[index]?.translations?.en?.firstName?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.translations.en.firstName`, {
                          required: { value: true, message: `${t('required')}` },
                          pattern: {
                            value: englishLetterRegex,
                            message: `${t('enterEnglishLetterAndRemoveSpaceValidation')}`,
                          },
                          minLength: { value: 2, message: `${t('minNameLetterLenght')}` },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      <Input
                        id={`surname-english-${index}`}
                        label={t('surnameInEnglish')}
                        type="text"
                        placeholder=""
                        value={item.translations?.en?.lastName}
                        name={`UserPersonalInfos.${index}.translations.en.lastName`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.translations?.en?.lastName}
                        errorText={errors.UserPersonalInfos?.[index]?.translations?.en?.lastName?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.translations.en.lastName`, {
                          required: { value: true, message: `${t('required')}` },
                          pattern: {
                            value: englishLetterRegex,
                            message: `${t('enterEnglishLetterAndRemoveSpaceValidation')}`,
                          },
                          minLength: { value: 2, message: `${t('minSurnameLetterLenght')}` },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      <ChooseGenderLabel style={{ color: errors.UserPersonalInfos?.[index]?.gender ? 'red' : 'black' }}>
                        {t('chooseGender')}
                      </ChooseGenderLabel>
                      <GenderBlock>
                        <GenderCard
                          selected={watch(`UserPersonalInfos.${index}.gender`) === 'female'}
                          gender="female"
                          femaleText={`${t('female')}`}
                          onClick={() => setValue(`UserPersonalInfos.${index}.gender`, 'female')}
                        />

                        <GenderCard
                          selected={watch(`UserPersonalInfos.${index}.gender`) === 'male'}
                          gender="male"
                          maleText={`${t('male')}`}
                          onClick={() => setValue(`UserPersonalInfos.${index}.gender`, 'male')}
                        />
                      </GenderBlock>

                      {(filter.attachedAddons && filter.attachedAddons.length >= 1) ||
                      (filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1) ? (
                        <AddonBlock>
                          <hr />
                          <AddonsLabel>{t('chooseExtraCoverages')}</AddonsLabel>
                          <AddonItems>
                            {filter.attachedAddons?.map((atAddon, atAddonIndex) => {
                              //
                              //
                              // @ts-ignore
                              const countIsEqual = (atAddonCounts?.[atAddon?.addon?.addonId] || 0) === atAddon.count
                              //
                              //
                              const travelerHaveAddon = item.addons?.find((x) => x.addonId === atAddon.addon.addonId)
                                ? true
                                : false
                              //
                              //
                              const showAddon = !countIsEqual || (countIsEqual && travelerHaveAddon)
                              //
                              //
                              if (showAddon) {
                                return (
                                  <AddonItem key={atAddonIndex}>
                                    <Checkbox
                                      id={`at-addon-id-${atAddonIndex}`}
                                      label={atAddon?.addon?.addonTranslations?.[lang]?.title || ''}
                                      defaultChecked={
                                        item.addons?.find((x) => x.addonId === atAddon.addon.addonId) ? true : false
                                      }
                                      onChange={(value) => {
                                        // add addon
                                        if (value === true) {
                                          addUserAtAddon(index, atAddon.addon)
                                        }
                                        // remove addon
                                        if (value === false) {
                                          removeUserAtAddon(index, atAddon.addon)
                                        }
                                      }}
                                    />
                                    <span>
                                      {atAddon.addon.paymentType === 'DAILY'
                                        ? parseFloat(atAddon.addon.premium) *
                                          (filter.offer?.calculatedPrices?.insurancesDays || 0)
                                        : parseFloat(atAddon.addon.premium)}{' '}
                                      ₾
                                    </span>
                                  </AddonItem>
                                )
                              } else {
                                return null
                              }
                              //
                            })}

                            {filter.groupedAttachedAddons?.map((groupAtAddon, groupAtAddonIndex) => {
                              //
                              //
                              const countIsEqual =
                                // @ts-ignore
                                (groupAtAddonCounts?.[groupAtAddon?.addon?.id] || 0) === groupAtAddon.count
                              //
                              //
                              const travelerHaveAddon = item.groupedAddonInfos?.find(
                                (x) => x.id === groupAtAddon.addon.id,
                              )
                                ? true
                                : false
                              //
                              //
                              const showAddon = !countIsEqual || (countIsEqual && travelerHaveAddon)
                              //
                              //
                              if (showAddon) {
                                return (
                                  <AddonItem key={groupAtAddonIndex}>
                                    <Checkbox
                                      id={`group-addon-id-${groupAtAddonIndex}`}
                                      label={groupAtAddon?.addon?.translations?.[lang]?.title || ''}
                                      defaultChecked={
                                        item.groupedAddonInfos?.find((x) => x.id === groupAtAddon.addon.id)
                                          ? true
                                          : false
                                      }
                                      onChange={(value) => {
                                        // add addon
                                        if (value === true) {
                                          addGroupUserAtAddon(index, groupAtAddon.addon)
                                        }
                                        // remove addons
                                        if (value === false) {
                                          removeUserGroupAtAddon(index, groupAtAddon.addon)
                                        }
                                      }}
                                    />
                                    <span>
                                      {groupAtAddon.addon.paymentType === 'DAILY'
                                        ? groupAtAddon.addon.premium *
                                          (filter.offer?.calculatedPrices?.insurancesDays || 0)
                                        : groupAtAddon.addon.premium}{' '}
                                      ₾
                                    </span>
                                  </AddonItem>
                                )
                              } else {
                                return null
                              }
                            })}
                          </AddonItems>
                        </AddonBlock>
                      ) : null}

                      {allAddonIsSelected !== true && totalFilterAddonCount && totalFilterAddonCount >= 1 ? (
                        <WarningMessage
                          variant="gray"
                          text={`${t('youHave')}  ${notUsedAddonCount} ${t('unusedCoverage')}`}
                        />
                      ) : null}
                    </Inputs>
                  ) : null}
                </WhiteBox>
              )
            })}

            {(travelersCountState && travelersInfo && travelersInfo.length === travelersCountState) ||
            (travelersCountState && travelersInfo && travelersInfo.length > travelersCountState) ? null : (
              <AddButtonStyle>
                <AddButton
                  text={t('addTraveler')}
                  onClick={() => [handleAddTraveler(), _toggleAccordion((openAccordion as number) + 1)]}
                />
              </AddButtonStyle>
            )}

            <Buttons>
              <NavigationButton
                text={`${t('back')}`}
                buttonType="prev"
                onClick={() => {
                  return [navigate('/who-do-you-insure'), dispatch(setTravelers(travelersInfo))]
                  //
                }}
              />
              <NavigationButton
                disabled={
                  isTravelersDateEqual === true &&
                  allAddonIsSelected === true &&
                  idNumbersIsValid &&
                  cityzenshipsIsValid &&
                  passportsIsValid &&
                  gendersIsValid === true
                    ? false
                    : true
                }
                text={`${t('next')}`}
                type="button"
                buttonType="next"
                onClick={handleSubmit(onSubmit)}
              />
            </Buttons>
          </Content>
        )}
      </form>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const AddButtonStyle = styled.div`
  margin-top: 60px;
  display: grid;
  place-items: center;
`
const CloseButton = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  transform: rotate(-90deg);
  position: absolute;
  left: 14px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 17px;
    height: 14px;
    color: ${Colors.primaryBlack};
  }

  ${Responsive.mobile} {
    left: 12px;
  }
`
const RemoveBtn = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  position: absolute;
  top: 16px;
  right: 16px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 13px;
    color: ${Colors.nevadaGrey};
  }

  ${Responsive.mobile} {
    svg {
      width: 14px;
      height: 11px;
    }
  }
`
const BlockHead = styled.div`
  display: flex;
  align-items: center;
`
const AddonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  label {
    pointer-events: none;
  }
`
const AddonItems = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 14px;
`
const AddonBlock = styled.div`
  /*  */
`
const AddonsLabel = styled.label`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 25px;
  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const ChooseGenderLabel = styled.label`
  font-size: 14px;
  color: ${Colors.primaryGrey};
`
const Inputs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  margin-top: 20px;
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  margin-inline: auto;
  border-radius: 8px;
  padding: 34px 48px;
  width: 100vw;
  position: relative;

  ${Responsive.mobile} {
    padding: 25px 20px;
    width: 100%;
  }
`
const BoxTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin: 0px;
  cursor: pointer;
  user-select: none;

  ${Responsive.mobile} {
    margin-left: 25px;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
  form {
    width: 100%;
  }
`
//
export default AbroadForOther
